import axios from '../axiosConfig'; // Assuming this is your configured Axios instance

import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const addToCart = async (productId, quantity = 1) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post('/product/cart', { product_id: productId, edition_id: null, quantity:quantity }, { headers });
    console.log(response);
    return response;
  } catch (error) { 
    return error;
  }
};



const modifyCartItem = async (data) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var cart_item_id = data.id;
  var add_value = data.add;
  var reduce_value = data.reduce;

  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post(`/product/cart/modify/${cart_item_id}?add_value=${add_value}&reduce_value=${reduce_value}`,{data}, { headers });
    return response;
  } catch (error) { 
    return error;
  }
};

const applyCoupon = async (cartId, couponCode) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post('/cart/coupon', { cart_id: cartId, coupon_code: couponCode }, { headers });
    return response.data;
  } catch (error) {
    console.error('Error applying coupon:', error);
    return null;
  }
};


const fetchCartList = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.get('/product/cart/list', {
      headers: headers
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching protected content:', error);
    return error;
  }
};

const removeCartItem = async (id) => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
  if (!axios.defaults.headers.common["Authorization"]) {
    // Try new auth system first (localStorage), fallback to old (sessionStorage)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem("authToken");
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  try {
    const response = await axios.post('/product/cart/delete', { item_id: id}, { headers });
    console.log(response);
    return response;
  } catch (error) { 
    return error;
  }
};



export { baseURL, fetchCartList , addToCart, modifyCartItem, applyCoupon,removeCartItem};